import { User } from '../../domain/entities/User';
import { Email } from '../../domain/valueObjects/Email';
import { Password } from '../../domain/valueObjects/Password';
import { IAuthRepository } from '../../domain/repositories/IAuthRepository';

/**
 * Application Service for Authentication
 * Follows Single Responsibility Principle
 */
export class AuthService {
  constructor(
    private readonly authRepository: IAuthRepository
  ) {}

  async login(
    email: string,
    password: string
  ): Promise<{ user: User; token: string }> {
    try {
      const emailVO = new Email(email);
      const passwordVO = new Password(password);

      return await this.authRepository.login(emailVO, passwordVO);
    } catch (error) {
      throw new Error(`Invalid email or password`);
    }
  }

    async register(userData: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    type: 'swimmer' | 'coach';
  }): Promise<{ user: User; token: string | null }> {
    try {
      const emailVO = new Email(userData.email);
      const passwordVO = new Password(userData.password);
      
      return await this.authRepository.register({
        email: emailVO,
        password: passwordVO,
        firstName: userData.firstName,
        lastName: userData.lastName,
        type: userData.type
      });
    } catch (error: any) {
      throw new Error(error.message || 'Registration failed');
    }
  }

  async validateToken(token: string): Promise<User | null> {
    try {
      return await this.authRepository.validateToken(token);
    } catch {
      return null;
    }
  }

  async refreshToken(token: string): Promise<string> {
    try {
      return await this.authRepository.refreshToken(token);
    } catch (error) {
      throw new Error(`Token refresh failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

async forgotPassword(email: string): Promise<{ success: boolean; message: string }> {
  const response = await this.authRepository.forgotPassword(email);

  return {
    success: response.status === 1,
    message: response.msg
  };
}



  // async forgotPassword(email: string): Promise<void> {
  //   try {
  //     const emailVO = new Email(email);
  //     await this.authRepository.forgotPassword(emailVO);
  //   } catch (error) {
  //     throw new Error(`Password reset request failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
  //   }
  // }

// async forgotPassword(email: string): Promise<{ success: boolean; message: string }> {
//   const emailVO = new Email(email);
//   return await this.authRepository.forgotPassword(emailVO);
// }

  async resetPassword(email: string, otp: string, newPassword: string): Promise<void> {
    try {
      const emailVO = new Email(email);
      const passwordVO = new Password(newPassword);
      
      await this.authRepository.resetPassword(emailVO, otp, passwordVO);
    } catch (error) {
      throw new Error(`Password reset failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  async changePassword(userId: string, currentPassword: string, newPassword: string): Promise<void> {
    try {
      const currentPasswordVO = new Password(currentPassword);
      const newPasswordVO = new Password(newPassword);
      
      await this.authRepository.changePassword(userId, currentPasswordVO, newPasswordVO);
    } catch (error) {
      throw new Error(`Password change failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  async logout(token: string): Promise<void> {
    try {
      await this.authRepository.logout(token);
    } catch (error) {
      // Logout should not throw errors
      console.warn('Logout warning:', error);
    }
  }
}
